import { render } from "./SpecValue.vue?vue&type=template&id=273861e4"
import script from "./SpecValue.vue?vue&type=script&lang=js"
export * from "./SpecValue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__